/* global window */
/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
import pathToRegexp from 'path-to-regexp'
import { YQL, CORS } from './request.config.js'
import {deepCopy, aesDoEncrypt} from './basicUtil'
import { localStorage } from './basicUtil'
import URI from 'urijs'
import router from '@router'

const tokenErrorCode = ['1020017000', '1021016097', '1021016098']
const instance = axios.create({
  headers: {'Content-Type': 'application/json;charset=UTF-8'},
  withCredentials: true,
  validateStatus: function (status) {
    return status >= 200 && status < 300 || status === 400; // 默认值 + 400 后端异常
  },
})
let Token = true
window.axios = instance

instance.interceptors.request.use(config => {
   return config
}, error => {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  if (response.data.code === '480' || response.data.code === '414' || tokenErrorCode.includes(response.data.errorCode)) {
    localStorage.delete('X-Access-Token')
    localStorage.delete('X-C-Token')
    router.push('/user/login')
    return response
  } else {
    return response
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
})

const axiosInstance = (options) => {
  let {
    method = 'get',
    data,
    fetchType,
    url,
    query = false,
    headers = {},
    params, // params用来填充url, 如pathToRegexp.compile('/user/:id')({id: 123})
    allParams = false,
    encrypt = false,
    auth = true,
  } = options

  headers = { 'Content-Type': 'application/json;charset=UTF-8', ...headers}

  if (auth && localStorage.get('X-Access-Token')) {
    headers['X-Access-Token'] = localStorage.get('X-Access-Token')
  }
  if (auth && localStorage.get('X-C-Token')) {
    headers['X-C-Token'] = localStorage.get('X-C-Token')
  }

  headers['PLATFORM-SOURCE'] = 'MOBILE'

  const cloneData = deepCopy(data)

  if (!allParams) {
    for (let ele in cloneData) {
      !cloneData[ele] && typeof cloneData[ele] !== "number" && delete cloneData[ele];
    }
    for (let key in cloneData) {
      typeof cloneData[key] === 'string' && !cloneData[key].length && delete cloneData[key]
    }
  }

  try {
    let domain = ''
    if (url.match(/[a-zA-z]+:\/\/[^/]*/)) {
      [domain] = url.match(/[a-zA-z]+:\/\/[^/]*/)
      url = url.slice(domain.length)
    }
    url = pathToRegexp.compile(url)(params)

    url = domain + url
  } catch (e) {

  }

  if (fetchType === 'YQL') {
    url = `http://query.yahooapis.com/v1/public/yql?q=select * from json where url='${options.url}?${encodeURIComponent(qs.stringify(options.data))}'&format=json`
    data = null
  }


  let requestData = ''
  //是否加密
  if (encrypt) {
    if (query || method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
      requestData = aesDoEncrypt(new URI('').addQuery(cloneData).toString().split('?')[1] || '')
    } else {
      requestData = aesDoEncrypt(cloneData)
    }
  } else {
    requestData = JSON.stringify(cloneData)
    if (query || method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
      requestData = cloneData
    }
  }

  if (query || method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
    url = new URI(url).addQuery(requestData).toString()
  }

  if (headers && headers['Content-Type'].includes('x-www-form-urlencoded')) {
    requestData = qs.stringify(cloneData)
  }
  switch (method.toLowerCase()) {
    case 'get':
      return instance.get(url, {headers})
    case 'delete':
      return instance.delete(url, {headers})
    case 'post':
      return instance.post(url, requestData, {headers})
    case 'put':
      return instance.put(url, requestData, {headers})
    case 'patch':
      return instance.patch(url, cloneData, {headers})
    default:
      return instance(options)
  }
}

const fetchInstance = (options) => {
  let {
    method = 'get',
    data,
    headers = { },
    fetchType,
    url,
    query = false,
    params, // params用来填充url, 如pathToRegexp.compile('/user/:id')({id: 123})
  } = options

  headers = { 'Content-Type': 'application/json;charset=UTF-8', ...headers}

  const cloneData = deepCopy(data)
  for (let ele in cloneData) {
    !cloneData[ele] && typeof cloneData[ele] !== "number" && delete cloneData[ele];
  }
  for (let key in cloneData) {
    typeof cloneData[key] === 'string' && !cloneData[key].length && delete cloneData[key]
  }

  try {
    let domain = ''
    if (url.match(/[a-zA-z]+:\/\/[^/]*/)) {
      [domain] = url.match(/[a-zA-z]+:\/\/[^/]*/)
      url = url.slice(domain.length)
    }
    url = pathToRegexp.compile(url)(params)
    url = domain + url
  } catch (e) {

  }

  if (query || method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
    url = new URI(url)
    .addQuery(cloneData).toString()

  }

  if (method === 'get' || method === 'delete') {
    url = new URI(url).addQuery(cloneData).toString()
  }
  switch (method.toLowerCase()) {
    case 'get':
      return window.fetch(url, {method: options.method, headers: {
        'Content-Type': 'application/json'
      }})
    case 'delete':
      url = url + '?' + qs.stringify(cloneData)
      return window.fetch(url, {method: options.method, headers: {
        'Content-Type': 'application/json'
      }, body: cloneData})
    case 'post':
      return window.fetch(url, {method: options.method, headers: {
        'Content-Type': 'application/json'
      }, body: JSON.stringify(cloneData)})
    case 'put':
      return window.fetch(url, {method: options.method, headers: {
        'Content-Type': 'application/json'
      }, body: JSON.stringify(cloneData)})
    case 'patch':
      return window.fetch(url, {method: options.method, headers: {
        'Content-Type': 'application/json'
      }, body: JSON.stringify(cloneData)})
    default:
      return null
  }
}
export default function request ({catchMessage = true, ...options}) {
  if (options.url && options.url.indexOf('//') > -1) {
    const origin = `${options.url.split('//')[0]}//${options.url.split('//')[1].split('/')[0]}`
    if (window.location.origin !== origin) {
      if (CORS && CORS.indexOf(origin) > -1) {
        options.fetchType = 'CORS'
      } else if (YQL && YQL.indexOf(origin) > -1) {
        options.fetchType = 'YQL'
      }
    }
  }

  if (options.responseType === 'blob') {
    return fetchInstance(options).then(res => res.blob()).then(blob => {
      return Promise.resolve({
        success: true,
        status: 'ok',
        statusCode: status,
        result: blob
      })
    })
  } else {
    return axiosInstance(options)
    .then((response) => {
      const { statusText, status } = response
      let data = options.fetchType === 'YQL' ? response.data.query.results.json : response.data
      if ( status === 200 && response.headers['content-type'].includes('application/json') && data.code === '200' ) {
        return Promise.resolve({
          success: true,
          status: 'ok',
          statusCode: status,
          result: data.data,
          message: data.message || '',
        })
      } else if (status === 400) {
        const { data = {} } = response
        return Promise.resolve({
          success: false,
          status: 'error',
          statusCode: status,
          result: data,
          message: data.message,
        })
      } else if (data.code === '855' || data.message === '资源限制功能无权限' || data.errorCode === '1021017127') {
        return Promise.resolve({
          success: false,
          status: 'error',
          statusCode: status,
          result: data,
          message: data.message || statusText,
        })
      } else {
        if (catchMessage) {
          // message.error(data.message)
        }
        return Promise.resolve({
          success: false,
          status: 'error',
          statusCode: status,
          result: data,
          message: data.message || statusText,
        })
      }
    }).catch((error) => {
      const { response} = error
      let msg
      let statusCode
      if (response && response instanceof Object) {
        const { data, statusText } = response
        statusCode = response.status
        msg = data.errorMsg || data.message || statusText
      } else {
        statusCode = 600
        msg = error.message || 'Network Error'
      }

      /* eslint-disable */
      return Promise.resolve({ success: false, statusCode, message: msg })
    })
  }
}
